export default "__VITE_ASSET__DhSMu7yB__"